import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import * as logger from "../../../logger";
import { deleteVendor } from '../../../store/actions/vehicleActionCreator';
import { connect } from "react-redux";

const useStyles = makeStyles((theme) => ({
    cancelV1: {
        color: '#6b778c', fontWeight: 'bold', fontSize: '16px', marginRight: '6px', letterSpacing: '0.05em'
    },
    deleteV1: {
        color: 'red', fontWeight: 'bold', fontSize: '16px', letterSpacing: '0.05em'
    },
    divV1: {
        fontWeight: 300, fontSize: 16
    }
}));

const DeleteSupplierDialog = ({ open, vendorId, onConfirm, onClose, dispatchDeleteVendor }) => {

    const [dialogOpen, setDialogOpen] = useState(open);

    const classes = useStyles();

    const handleDialogClose = () => {
        setDialogOpen(false);
        onClose();
    }


    const onDelete = () => {
        dispatchDeleteVendor(vendorId,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Delete Vendor Dialog Dweb", "Delete Vendor Successfull");
                    setDialogOpen(false);
                    onConfirm();
                }
            },
            () => {
                logger.log("Delete Vendor Dialog Dweb", "Delete Vendor Failed");
            }
        )
    }

    return (
        <>
            <Dialog
                fullWidth={true}
                maxWidth='xs'
                disableBackdropClick={true} disableEscapeKeyDown={true} open={dialogOpen} onClose={handleDialogClose}
            >
                <DialogContent>
                    <div className={classes.divV1}>Do you want to delete the Supplier ? </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose}>
                        <span className={classes.cancelV1}>
                            CANCEL
                        </span>
                    </Button>
                    <Button onClick={onDelete}>
                        <span className={classes.deleteV1}>
                            DELETE
                        </span>
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )

}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
    dispatchDeleteVendor: (id, onSuccess, onFailure) => dispatch(deleteVendor(id, onSuccess, onFailure))
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteSupplierDialog);
